import { useState } from "react";
import {
  errorClassName,
  errorIconClassName,
  hintClassName,
  inputClassNameSize,
  inputContainerClassNameWithLable,
  inputIconSize,
  labelClassName,
} from "./constants";
import { twMerge } from "tailwind-merge";
import { UseInputParams } from "./types";

const useInput = ({
  size,
  title,
  error,
  successMessage,
  disabled,
  parentClassName,
  startIcon,
  startIconClassName,
  endIconClassName,
  inputClassName,
  extraLabelClassName,
}: UseInputParams) => {
  const [hasFocus, setHasFocus] = useState(false);

  const labelClass = twMerge(
    "text-fds-primary",
    labelClassName[size],
    disabled ? "text-fds-disable" : "",
    extraLabelClassName
  );

  const containerClass = twMerge(
    "flex w-full border items-center",
    hasFocus ? "border-fds-select" : "border-fds-default",
    error ? "!border-fds-danger" : successMessage && "!border-fds-icon-success",
    inputClassNameSize[size],
    title && inputContainerClassNameWithLable[size],
    parentClassName
  );

  const inputClass = twMerge(
    "w-full bg-fds-primary grow autofill:shadow-[0_0_0_30px_white_inset] shrink-0 placeholder:text-right placeholder:font-normal focus-visible:!outline-none",
    inputClassName,
    startIcon && "pr-6"
  );

  const startIconClass = twMerge(
    "right-2.5 absolute cursor-pointer",
    inputIconSize[size],
    startIconClassName
  );

  const endIconClass = twMerge(
    "absolute cursor-pointer text-fds-icon-secondary left-2.5",
    inputIconSize[size],
    endIconClassName
  );

  const clearIconClass = twMerge(
    "text-fds-icon-secondary",
    inputIconSize[size]
  );

  const errorContainerClass = twMerge(
    "flex self-start items-center",
    errorClassName[size]
  );

  const errorIconClass = twMerge(
    "text-fds-danger ml-1",
    errorIconClassName[size]
  );

  const errorTextClass = twMerge(hintClassName[size], "text-fds-danger");

  const successTextClass = twMerge(hintClassName[size], "text-fds-success");

  const hintTextClass = twMerge(
    hintClassName[size],
    "text-fds-tertiary self-end"
  );

  return {
    hasFocus,
    setHasFocus,
    labelClass,
    containerClass,
    inputClass,
    startIconClass,
    endIconClass,
    clearIconClass,
    errorContainerClass,
    errorIconClass,
    errorTextClass,
    successTextClass,
    hintTextClass,
  };
};

export default useInput;
